const o = "_confirmationDialogActions_63uxe_1", i = "_vertical_63uxe_9", t = {
  confirmationDialogActions: o,
  vertical: i
};
export {
  o as confirmationDialogActions,
  t as default,
  i as vertical
};
//# sourceMappingURL=index.es5621.js.map
